import { LazySvg } from './LazyImport/LazySvg'
import { lazy } from 'react'

export { default as catchError, getToken, handleRequest, getDate, getSortBy, getTime, slugify, setToken, setDefaultAll, getPathName, getRedirectPath, ScrollToTop, getFieldErrorMessage, scrollFocus, nextOnEnter, delayForFunction, getFormatedAmount, CheckItemInCartItemList, getIframeScr, getDiscount, copyToClipboard, isValidLink, normalizeColorForJsonLd, normalizeColorForApi } from './CodeEasier'
export { default as errorName, path, pattern, fallbackImg, delivery_charge, min_price, defaultMetaTagImage, vidoeThumbnail, base_loading_time, shopOption, max_price, categoryOption, static_img_url, app_name, whatsapp_number_1, whatsapp_number_2, phone_number_1, phone_number_2, instagram_link, facebook_link, whatsapp_channel_link, whatsapp_link, email, important_links, intersection_threshold, productSharingMessage, pageSharingMessage, shopSharingMessage, orderStatus, kotak_upi_id } from './Variables'
export { default as ErrorUp } from './Handlers/ErrorUp'
export { default as PageLoading } from './Handlers/PageLoading'
export { default as StartLoading } from './Handlers/StartLoading'
export { default as NoConnection } from './Handlers/NoConnection'
export { default as NoData } from './Handlers/NoData'
export { default as NotAuthorized } from './Handlers/NotAuthorized'
export { default as NotFound404 } from './Handlers/NotFound404'
export { default as Sloading } from './Handlers/Sloading';
export { default as SuccessUp } from './Handlers/SuccessUp'
export { default as FieldError } from './Handlers/FieldError'
export { default as InternalError } from './Handlers/InternalError'
export { default as NotNormalUser } from './Handlers/NotNormalUser'
export { default as RequestLimt } from './Handlers/RequestLimt'
export { default as InfoPopUp } from './Handlers/InfoPopUp'


export const EditIcon = LazySvg(lazy(() => import('./svg/EditIcon')));
export const PhoneIcon = LazySvg(lazy(() => import('./svg/PhoneIcon')));
export const HomeIcon = LazySvg(lazy(() => import('./svg/HomeIcon')));
export const SearchIcon = LazySvg(lazy(() => import('./svg/SearchIcon')));
export const CrossIcon = LazySvg(lazy(() => import('./svg/CrossIcon')));
export const GroupWhatsappIcon = LazySvg(lazy(() => import('./svg/GroupWhatsappIcon')));
export const DiscountIcon = LazySvg(lazy(() => import('./svg/DiscountIcon')));
export const FacebookIcon = LazySvg(lazy(() => import('./svg/FacebookIcon')));
export const InfoIcon = LazySvg(lazy(() => import('./svg/InfoIcon')));
export const InstagramIcon = LazySvg(lazy(() => import('./svg/InstagramIcon')));
export const RightIcon = LazySvg(lazy(() => import('./svg/RightIcon')));
export const OpenLinkIcon = LazySvg(lazy(() => import('./svg/OpenLinkIcon')));
export const ToolboxIcon = LazySvg(lazy(() => import('./svg/ToolboxIcon')));
export const CartIcon = LazySvg(lazy(() => import('./svg/CartIcon')));
export const ShopIcon = LazySvg(lazy(() => import('./svg/ShopIcon')));
export const DeleteIcon = LazySvg(lazy(() => import('./svg/DeleteIcon')));
export const DropDownIcon = LazySvg(lazy(() => import('./svg/DropDownIcon')));
export const LinkIcon = LazySvg(lazy(() => import('./svg/LinkIcon')));
export const WhatsappIcon = LazySvg(lazy(() => import('./svg/WhatsappIcon')));
export const BilldeskIcon = LazySvg(lazy(() => import('./svg/BilldeskIcon')));
export const CustomerIcon = LazySvg(lazy(() => import('./svg/CustomerIcon')));
export const RightArrowIcon = LazySvg(lazy(() => import('./svg/RightArrowIcon')));
export const PlusIcon = LazySvg(lazy(() => import('./svg/PlusIcon')));
export const UsersIcon = LazySvg(lazy(() => import('./svg/UsersIcon')));
export const UserIcon = LazySvg(lazy(() => import('./svg/UserIcon')));
export const MenuIcon = LazySvg(lazy(() => import('./svg/MenuIcon')));
export const CategoryIcon = LazySvg(lazy(() => import('./svg/CategoryIcon')));
export const ProductIcon = LazySvg(lazy(() => import('./svg/ProductIcon')));
export const CopyIcon = LazySvg(lazy(() => import('./svg/CopyIcon')));
export const ShareIcon = LazySvg(lazy(() => import('./svg/ShareIcon')));
export const OrderIcon = LazySvg(lazy(() => import('./svg/OrderIcon')));
export const NotificationIcon = LazySvg(lazy(() => import('./svg/NotificationIcon')));
export const CustomWeightIcon = LazySvg(lazy(() => import('./svg/CustomWeightIcon')));
export const GeoLocationIcon = LazySvg(lazy(() => import('./svg/GeoLocationIcon')));
export const LockIcon = LazySvg(lazy(() => import('./svg/LockIcon')));
export const RefreshIcon = LazySvg(lazy(() => import('./svg/RefreshIcon')));
export const YoutubeIcon = LazySvg(lazy(() => import('./svg/YoutubeIcon')));
export const EmailIcon = LazySvg(lazy(() => import('./svg/EmailIcon')));
export const LikeIcon = LazySvg(lazy(() => import('./svg/LikeIcon')));
export const FilterIcon = LazySvg(lazy(() => import('./svg/FilterIcon')));
export const OrderByIcon = LazySvg(lazy(() => import('./svg/OrderByIcon')));
export const LocationIcon = LazySvg(lazy(() => import('./svg/LocationIcon')));
export const ShieldIcon = LazySvg(lazy(() => import('./svg/ShieldIcon')));
export const PasswordIcon = LazySvg(lazy(() => import('./svg/PasswordIcon')));
export const InquiryIcon = LazySvg(lazy(() => import('./svg/InquiryIcon')));
export const QuestionMarkIcon = LazySvg(lazy(() => import('./svg/QuestionMarkIcon')));
export const ListIcon = LazySvg(lazy(() => import('./svg/ListIcon')));

export { default as LazyImage } from './Handlers/LazyImage'
export { default as LazyVideo } from './Handlers/LazyVideo'


// lazy imports

export { default as LazyShareButtons } from './LazyImport/LazyShareButtons'
export { default as LazyHelmet } from './LazyImport/LazyHelmet'
export { default as LazyAxios } from './LazyImport/LazyAxios'